<template>
  <div>
    <b-tabs>
      <span v-if="!isEditing" class="text-danger" style="font-size: 12px">
        Preencha os Dados do Tomador e edite o cadastro para inserir os dados do Segurado/Beneficiário.
      </span>
      <!-- Dados Cadastrais -->
      <validation-observer ref="formDadosCadastraisEnderecoBancarios">
        <b-tab>
          <template #title>
            <feather-icon icon="HomeIcon" />
            <span>Dados Cadastrais</span>
          </template>

          <b-row>
            <b-col md="3">
              <b-form-group label="Foto" label-for="foto" style="margin-bottom: 0">
                <div class="profile-img">
                  <span v-if="!dados.foto" class="b-avatar badge-secondary rounded" style="width: 160px; height: 120px">
                    <feather-icon icon="UserIcon" fill="currentColor" size="80" />
                  </span>

                  <img
                    v-if="dados.foto"
                    :src="dados.foto.foto"
                    class="img-fluid rounded"
                    style="max-height: 120px"
                    :alt="dados.foto.alt || 'Imagem de usuário'"
                  />

                  <div style="bottom: -30px; text-align: center; width: 160px; z-index: 1">
                    <b-button
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-success"
                      class="btn-icon rounded-circle"
                      @click="capturarFoto()"
                    >
                      <feather-icon icon="CameraIcon" />
                    </b-button>

                    <b-button
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-danger"
                      class="btn-icon rounded-circle"
                      @click="limparFoto()"
                    >
                      <feather-icon icon="XSquareIcon" />
                    </b-button>
                  </div>
                </div>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Nome Completo" label-for="nomeCompleto">
                <validation-provider #default="{ errors }" name="Nome Completo" rules="required">
                  <b-form-input
                    id="nomeCompleto"
                    type="text"
                    placeholder="Nome Completo"
                    v-model="dados.nomeCompleto"
                    v-on:keypress="isLetter($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Nome Social" label-for="nomeSocial">
                <b-form-input id="nomeSocial" type="text" placeholder="Nome Social" v-model="dados.nomeSocial" />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="CPF" label-for="cpf">
                <validation-provider #default="{ errors }" name="CPF" rules="required">
                  <cleave
                    id="cpf"
                    type="text"
                    placeholder="CPF"
                    v-model="dados.cpf"
                    :raw="false"
                    :options="options.cleaveCPF"
                    class="form-control"
                    @input="removePontos"
                    @blur="validaCamposDocumentos((campo = dados.cpf), (id = 'cpf'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group label="Data Nascimento" label-for="dataNascimento">
                <validation-provider #default="{ errors }" name="Data Nascimento" rules="required|date">
                  <cleave
                    id="dataNascimento"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    v-model="dados.dataNascimento"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Unidade Gestora" label-for="unidadeGestora">
                <validation-provider #default="{ errors }" name="Unidade Gestora" rules="required">
                  <v-select-pt
                    id="selectUnidadeGestora"
                    name="selectUnidadeGestora"
                    v-model="dados.institutoId"
                    v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                    :options="clientes"
                    :reduce="(option) => option.id"
                    label="nome"
                    placeholder="Selecione:"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Sexo" label-for="sexo">
                <validation-provider #default="{ errors }" name="Sexo" rules="required">
                  <b-form-select name="sexo" v-model="dados.sexo" :options="sexoOpcoes"></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Gênero" label-for="genero">
                <validation-provider #default="{ errors }" name="Gênero" rules="required">
                  <b-form-select name="genero" v-model="dados.genero" :options="generoOpcoes"></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Estado Civil" label-for="estadoCivil">
                <validation-provider #default="{ errors }" name="Estado Civil" rules="required">
                  <b-form-select name="estadoCivil" v-model="dados.estadoCivil" :options="estadoCivilOpcoes"> </b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-show="dados.estadoCivil === 'Casado(a)'">
            <b-col md="6">
              <b-form-group label="Nome do Cônjuge" label-for="nomeConjuge">
                <validation-provider #default="{ errors }" name="Nome do Cônjuge">
                  <b-form-input
                    id="nomeConjuge"
                    type="text"
                    placeholder="Nome do Cônjuge"
                    v-model="dados.nomeConjuge"
                    :rules="{ required: dados.estadoCivil == 'Casado(a)' }"
                    v-on:keypress="isLetter($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="CPF do Cônjuge" label-for="cpfConjuge">
                <validation-provider #default="{ errors }" name="CPF do Cônjuge">
                  <cleave
                    id="cpfConjuge"
                    type="text"
                    placeholder="CPF do Cônjuge"
                    v-model="dados.cpfConjuge"
                    :rules="{ required: dados.estadoCivil == 'Casado(a)' }"
                    :raw="false"
                    :options="options.cleaveCPF"
                    class="form-control"
                    @input="removePontos"
                    @blur="validaCamposDocumentos((campo = dados.cpf), (id = 'cpf'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group label="Nome da Mãe" label-for="nomeMae">
                <validation-provider #default="{ errors }" name="Nome da Mãe" rules="required">
                  <b-form-input
                    id="nomeMae"
                    type="text"
                    placeholder="Nome da Mãe"
                    v-model="dados.nomeMae"
                    v-on:keypress="isLetter($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Nome da Pai" label-for="nomePai">
                <b-form-input
                  id="nomePai"
                  type="text"
                  placeholder="Nome da Pai"
                  v-model="dados.nomePai"
                  v-on:keypress="isLetter($event)"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Nacionalidade" label-for="nacionalidade">
                <validation-provider #default="{ errors }" name="Nacionalidade" rules="required">
                  <v-select-pt
                    name="nacionalidade"
                    v-model="dados.nacionalidade"
                    v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                    :options="nacionalidade"
                    :reduce="(option) => option.codigoFederal"
                    label="nome"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-form-group label="UF Naturalidade" label-for="ufNaturalidade">
              <validation-provider #default="{ errors }" name="UF Naturalidade" rules="required">
                <b-form-select
                  id="ufNaturalidade"
                  name="ufNaturalidade"
                  v-model="dados.ufNaturalidade"
                  :options="ufOpcoes"
                  v-on:change="limparValoresEstado"
                ></b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-col md="6">
              <b-form-group label="Naturalidade" label-for="naturalidade">
                <validation-provider #default="{ errors }" name="Naturalidade" rules="required">
                  <v-select-pt
                    name="naturalidade"
                    v-model="dados.naturalidade"
                    v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                    :options="cidadeNaturalidade"
                    :reduce="(option) => option.nome"
                    label="nome"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="RG Nº" label-for="rgNumero">
                <validation-provider #default="{ errors }" name="RG Nº" rules="required">
                  <cleave
                    id="rgNumero"
                    type="text"
                    placeholder="RG Nº"
                    v-model="dados.rgNumero"
                    :raw="false"
                    :options="options.cleaveRG"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Data Emissão" label-for="rgDataEmissao">
                <validation-provider
                  #default="{ errors }"
                  name="Data Emissão"
                  :rules="{
                    required: true,
                    date: true,
                    dataPassada: {
                      value: dados.rgDataEmissao,
                      dataParametro: dados.dataNascimento,
                      stringParametro: 'data de nascimento',
                    },
                  }"
                >
                  <cleave
                    id="rgDataEmissao"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    v-model="dados.rgDataEmissao"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="RG Órgão Emissor" label-for="rgOrgaoEmissor">
                <validation-provider #default="{ errors }" name="RG Órgão Emissor" rules="required">
                  <b-form-select
                    id="rgOrgaoEmissor"
                    v-model="dados.rgOrgaoEmissor"
                    placeholder="RG Órgão Emissor"
                    :options="orgaosEmissores"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="UF de Expedição do RG" label-for="rgUF">
                <validation-provider #default="{ errors }" name="UF de Expedição do RG" rules="required">
                  <b-form-select id="rgUF" name="rgUF" v-model="dados.rgUF" :options="ufOpcoes"></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Telefone" label-for="telefone">
                <validation-provider #default="{ errors }" name="Telefone" rules="required|telefone">
                  <cleave
                    id="telefone"
                    type="text"
                    placeholder="Telefone"
                    v-model="dados.telefone"
                    :raw="false"
                    :options="options.cleavePhone"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="9">
              <b-form-group label="E-mail" label-for="email">
                <validation-provider #default="{ errors }" name="E-mail" rules="required|email">
                  <b-form-input id="email" type="text" placeholder="E-mail" v-model="dados.email" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Possui CNH?" label-for="possuiCNH" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="possuiCNH"
                  v-model="dados.possuiCNH"
                  :options="optionsSimNao"
                  :aria-describedby="ariaDescribedby"
                  button-variant="outline-primary"
                  class="w-100"
                  name="radio-btn-outline"
                  buttons
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                label="Possui parente PPE*?"
                v-b-tooltip.hover.up="
                  'Se o tomador possui algum parente de primeiro grau (pai, mãe, irmãos, cônjuge, filhos) que seja considerado uma Pessoa Politicamente Exposta'
                "
                label-for="possuiParentePPE"
                v-slot="{ ariaDescribedby }"
              >
                <validation-provider #default="{ errors }" name="Possui parente PPE" rules="required">
                  <b-form-radio-group
                    id="possuiParentePPE"
                    v-model="dados.possuiParentePPE"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Portador de Moléstia Grave?" label-for="portadorMolestiaGrave" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Portador de Moléstia Grave?" rules="required">
                  <b-form-radio-group
                    id="portadorMolestiaGrave"
                    v-model="dados.portadorMolestiaGrave"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Portador de Doença Incapacitante?" label-for="email" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Portador de Doença Incapacitante?" rules="required">
                  <b-form-radio-group
                    id="portadorDoencaIncapacitante"
                    v-model="dados.portadorDoencaIncapacitante"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="dados.id">
              <b-form-group label="Falecido?" label-for="falecido" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Falecido?" rules="required">
                  <b-form-radio-group
                    id="falecido"
                    v-model="dados.falecido"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group
                label="Tomador é um PPE*?"
                v-b-tooltip.hover.up="'Se o tomador é considerado uma Pessoa Politicamente Exposta'"
                label-for="tomadorPPE"
                v-slot="{ ariaDescribedby }"
              >
                <validation-provider #default="{ errors }" name="Tomador é um PPE" rules="required">
                  <b-form-radio-group
                    id="tomadorPPE"
                    v-model="dados.tomadorPPE"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="dados.tomadorPPE">
              <b-form-group label="Cargo do Tomador PPE" label-for="cargoTomadorPPE" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Cargo do Tomador PPE" rules="required">
                  <b-form-input
                    id="cargoTomadorPPE"
                    type="text"
                    placeholder="Cargo do Tomador PPE"
                    v-model="dados.cargoTomadorPPE"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- CNH -->
          <b-row v-show="dados.possuiCNH">
            <b-col cols="12">
              <hr class="my-2" />
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center mt-2 mb-2">
              <h2>Dados da CNH</h2>
            </b-col>

            <b-col md="3">
              <b-form-group label="CNH Nº" label-for="cnhNumero">
                <validation-provider #default="{ errors }" :rules="{ required: dados.possuiCNH }" name="CNH Nº">
                  <cleave
                    type="text"
                    :raw="false"
                    class="form-control"
                    :options="options.cleaveCnh"
                    id="cnhNumero"
                    placeholder="CNH Nº"
                    v-model="dados.cnhNumero"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Categoria CNH" label-for="cnhCategoria">
                <validation-provider #default="{ errors }" name="Categoria CNH" :rules="{ required: dados.possuiCNH }">
                  <v-select-pt
                    id="cnhCategoria"
                    name="cnhCategoria"
                    v-model="dados.cnhCategoria"
                    :options="optionsCnhCategorias"
                    :reduce="(option) => option.id"
                    label="label"
                    :clearable="false"
                  >
                  </v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Órgão Expedidor" label-for="orgaoExpedidorCNH">
                <validation-provider #default="{ errors }" name="Orgão Expedidor" :rules="{ required: dados.possuiCNH }">
                  <b-form-input
                    id="orgaoExpedidorCNH"
                    type="text"
                    placeholder="Órgão Expedidor"
                    v-bloqueioCaractereMask="{ tamanho: 10, regex: /[^a-zA-Z]/g }"
                    v-model="dados.orgaoExpedidorCNH"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Data de Expedição CNH" label-for="cnhDataExpedicao">
                <validation-provider
                  #default="{ errors }"
                  name="Data de Expedição CNH"
                  :rules="{
                    required: dados.possuiCNH,
                    dataPassada: {
                      value: dados.cnhDataExpedicao,
                      dataParametro: dados.dataNascimento,
                      stringParametro: 'data de nascimento',
                    },
                  }"
                >
                  <cleave
                    id="cnhDataExpedicao"
                    v-model="dados.cnhDataExpedicao"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Data de Validade CNH" label-for="cnhDataValidade">
                <validation-provider
                  #default="{ errors }"
                  name="Data de Validade CNH"
                  :rules="{
                    required: dados.possuiCNH,
                    dataPassada: {
                      value: dados.cnhDataExpedicao,
                      dataParametro: dados.dataNascimento,
                      stringParametro: 'data de expedição da CNH',
                    },
                  }"
                >
                  <cleave
                    id="cnhDataValidade"
                    v-model="dados.cnhDataValidade"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Parente PPE -->
          <b-row v-show="dados.possuiParentePPE">
            <b-col cols="12">
              <hr class="my-2" />
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center mt-2 mb-2">
              <h2 v-b-tooltip.hover.up="'Pessoa Politicamente Exposta'">Dados do Parente PPE</h2>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center">
              <b-col md="3">
                <b-form-group label="Nome do Parente PPE" label-for="nomeParentePPE" v-slot="{ ariaDescribedby }">
                  <validation-provider
                    #default="{ errors }"
                    name="Nome do Parente PPE"
                    :rules="{ required: dados.possuiParentePPE }"
                  >
                    <b-form-input
                      id="nomeParentePPE"
                      type="text"
                      placeholder="Nome do Parente PPE"
                      v-model="dados.nomeParentePPE"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group
                  label="Cargo Público do Parente PPE"
                  label-for="cargoPublicoParentePPE"
                  v-slot="{ ariaDescribedby }"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Cargo Público do Parente PPE"
                    :rules="{ required: dados.possuiParentePPE }"
                  >
                    <b-form-input
                      id="cargoPublicoParentePPE"
                      type="text"
                      placeholder="Cargo Público do Parente PPE"
                      v-model="dados.cargoPublicoParentePPE"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Grau de Parentesco" label-for="grauParentescoParentePPE" v-slot="{ ariaDescribedby }">
                  <validation-provider
                    #default="{ errors }"
                    name="Grau de Parentesco"
                    :rules="{ required: dados.possuiParentePPE }"
                  >
                    <b-form-input
                      id="grauParentescoParentePPE"
                      type="text"
                      placeholder="Grau de Parentesco"
                      v-model="dados.grauParentescoParentePPE"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-col>
          </b-row>

          <!-- Falecido -->
          <b-row v-show="dados.falecido">
            <b-col cols="12">
              <hr class="my-2" />
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center mt-2 mb-2">
              <h2>Dados do Óbito</h2>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center">
              <b-col md="3" v-if="dados.id && dados.falecido">
                <b-form-group label="Data do Óbito" label-for="dataObito">
                  <validation-provider
                    #default="{ errors }"
                    name="Data do Óbito"
                    :rules="{
                      required: dados.falecido,
                      dataPassada: {
                        value: dados.dataObito,
                        dataParametro: dados.dataNascimento,
                        stringParametro: 'data de nascimento',
                      },
                      dataFutura: true,
                    }"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          button-variant="primary"
                          class="datePickerWithInput"
                          right
                          button-only
                          v-model="datePicker.dataObito"
                          :hide-header="true"
                          :initial-date="new Date()"
                          :state="errors[0] ? false : null"
                          label-help=""
                          label-calendar="Calendário"
                          label-close-button="Fechar"
                          label-current-month="Mês atual"
                          label-next-decade="Próxima década"
                          label-next-month="Próximo mês"
                          label-next-year="Próximo ano"
                          label-prev-decade="Década anterior"
                          label-prev-month="Mês anterior"
                          label-prev-year="Ano anterior"
                          label-select-month="Selecione o mês"
                          label-select-year="Selecione o ano"
                          label-selected="Selecionado"
                          label-no-date-selected="Nenhuma data selecionada"
                          label-reset-button="Resetar"
                          label-today-button="Hoje"
                          label-today="Hoje"
                          locale="pt-BR"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                          aria-controls="dataObito"
                        />
                      </b-input-group-prepend>

                      <cleave
                        id="dataObito"
                        type="text"
                        v-model="dados.dataObito"
                        placeholder="DD/MM/AAAA"
                        class="form-control cleave-height"
                        :options="options.cleaveDate"
                        :raw="false"
                      />
                    </b-input-group>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="dados.falecido && dados.id">
                <div class="flex w-full items-center justify-center" id="app">
                  <div class="p-12 bg-gray-100">
                    <validation-provider #default="{ errors }" name="Certidão de Óbito" :rules="{ required: dados.falecido }">
                      <b-form-group label="Certidão de Óbito" label-for="certidaoObito">
                        <b-form-file
                          id="certidaoObito"
                          :state="Boolean(dados.certidaoObito)"
                          ref="certidaoObitoFile"
                          accept=".pdf"
                          placeholder="Escolha um arquivo ou arraste até aqui ..."
                          drop-placeholder="Solte o arquivo aqui..."
                          browse-text="Escolher"
                          v-model="dados.certidaoObito"
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </div>
              </b-col>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Endereço -->
        <b-tab>
          <template #title>
            <feather-icon icon="MapPinIcon" />
            <span>Endereço</span>
          </template>

          <b-row>
            <b-col md="3">
              <b-form-group label="País de Residência" label-for="País de Residência">
                <validation-provider #default="{ errors }" name="País de Residência" rules="required">
                  <v-select-pt
                    id="paisResidenciaEnderecoEstrangeiro"
                    v-model="dados.paisResidenciaEnderecoEstrangeiro"
                    v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                    :options="nacionalidade"
                    :reduce="(option) => option.nome"
                    label="nome"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <div v-if="dados.paisResidenciaEnderecoEstrangeiro == 'Brasil'">
            <b-row>
              <b-col md="2">
                <b-form-group label="CEP" label-for="cepEndereco">
                  <validation-provider #default="{ errors }" name="CEP" rules="required|cep">
                    <cleave
                      id="cepEndereco"
                      type="text"
                      placeholder="CEP"
                      v-model="dados.cepEndereco"
                      maxlength="10"
                      @keyup.native="buscarCEP"
                      :raw="false"
                      :options="options.cleaveCEP"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="5">
                <b-form-group label="Logradouro" label-for="logradouroEndereco">
                  <validation-provider #default="{ errors }" name="Logradouro" rules="required">
                    <b-form-input
                      v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^\w ]/ }"
                      id="logradouroEndereco"
                      type="text"
                      placeholder="Logradouro"
                      v-model="dados.logradouroEndereco"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Número" label-for="numeroEndereco">
                  <validation-provider #default="{ errors }" name="Número" rules="required">
                    <b-form-input id="numeroEndereco" type="text" placeholder="Número" v-model="dados.numeroEndereco" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="Complemento" label-for="complementoEndereco">
                  <b-form-input
                    id="complementoEndereco"
                    type="text"
                    placeholder="Complemento"
                    v-model="dados.complementoEndereco"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Bairro" label-for="bairroEndereco">
                  <validation-provider #default="{ errors }" name="Bairro" rules="required|min:2">
                    <b-form-input id="bairroEndereco" type="text" placeholder="Bairro" v-model="dados.bairroEndereco" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group label="UF" label-for="ufEndereco">
                  <validation-provider #default="{ errors }" name="UF" rules="required">
                    <b-form-select
                      name="ufEndereco"
                      v-model="dados.ufEndereco"
                      :options="ufOpcoes"
                      v-on:change="carregarCidadeEndereco"
                    ></b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="5">
                <b-form-group label="Cidade" label-for="cidadeEndereco">
                  <validation-provider #default="{ errors }" name="Cidade" rules="required">
                    <v-select-pt
                      name="cidadeEndereco"
                      v-model="dados.cidadeEndereco"
                      v-bloqueioCaractereMask="{ tamanho: 50, regex: /[^a-zA-Z]/g }"
                      :options="cidadeEndereco"
                      :reduce="(option) => option.nome"
                      label="nome"
                    ></v-select-pt>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <small class="text-primary d-block"
                    >Digite o CEP, ou selecione a UF, para que as cidades sejam carregadas</small
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <div v-else>
            <b-row>
              <b-col md="4">
                <b-form-group label="Cidade de Residência" label-for="cidadeResidenciaEnderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Cidade de Residência" rules="required">
                    <b-form-input
                      id="cidadeResidenciaEnderecoEstrangeiro"
                      type="text"
                      placeholder="Cidade de Residência"
                      v-model="dados.cidadeResidenciaEnderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Lotado/Província" label-for="estadoProvinciaEnderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Lotado/Província">
                    <b-form-input
                      id="estadoProvinciaEnderecoEstrangeiro"
                      type="text"
                      placeholder="Lotado/Província"
                      v-model="dados.estadoProvinciaEnderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Endereço" label-for="enderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Endereço">
                    <b-form-input
                      id="enderecoEstrangeiro"
                      type="text"
                      placeholder="Endereço"
                      v-model="dados.enderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label="Código Postal" label-for="codigoPostalEnderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Código Postal">
                    <b-form-input
                      id="codigoPostalEnderecoEstrangeiro"
                      type="text"
                      placeholder="Código Postal"
                      v-model="dados.codigoPostalEnderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Número" label-for="numeroEnderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Número">
                    <b-form-input
                      id="numeroEnderecoEstrangeiro"
                      type="text"
                      placeholder="Número"
                      v-model="dados.numeroEnderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Complemento" label-for="complementoEnderecoEstrangeiro">
                  <validation-provider #default="{ errors }" name="Complemento">
                    <b-form-input
                      id="complementoEnderecoEstrangeiro"
                      type="text"
                      placeholder="Complemento"
                      v-model="dados.complementoEnderecoEstrangeiro"
                      class="form-control"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <b-row>
            <b-col md="3">
              <b-form-group
                label="Possui domicílio fiscal nos EUA?"
                label-for="domicilioFiscaoEUA"
                v-slot="{ ariaDescribedby }"
              >
                <validation-provider #default="{ errors }" name="Possui domicílio fiscal?" rules="required">
                  <b-form-radio-group
                    id="domicilioFiscaoEUA"
                    v-model="dados.domicilioFiscaoEUA"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="dados.domicilioFiscaoEUA">
              <b-form-group
                label="Número de identificação fiscal (TIN)"
                label-for="numeroIdentificacaoFiscal"
                v-slot="{ ariaDescribedby }"
              >
                <validation-provider #default="{ errors }" name="Número de identificação fiscal (TIN)" rules="required">
                  <b-form-input
                    id="numeroIdentificacaoFiscal"
                    type="text"
                    placeholder="Número de identificação fiscal (TIN)"
                    v-model="dados.numeroIdentificacaoFiscal"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6" v-if="dados.domicilioFiscaoEUA">
              <b-form-group
                label="Endereço Fiscal nos Estados Unidos"
                label-for="enderecoFiscalEUA"
                v-slot="{ ariaDescribedby }"
              >
                <validation-provider #default="{ errors }" name="Endereço Fiscal nos Estados Unidos" rules="required">
                  <b-form-input
                    id="enderecoFiscalEUA"
                    type="text"
                    placeholder="Endereço Fiscal nos Estados Unidos"
                    v-model="dados.enderecoFiscalEUA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Dados Bancários -->
        <b-tab>
          <template #title>
            <feather-icon icon="DollarSignIcon" />
            <span>Dados Bancários</span>
          </template>

          <b-row>
            <b-col md="6">
              <b-form-group label="Banco" label-for="dadoBancarioBanco">
                <validation-provider #default="{ errors }" name="Banco" rules="required">
                  <v-select-pt
                    name="dadoBancarioBanco"
                    v-model="dados.bancoId"
                    :options="banco"
                    :reduce="(option) => option.id"
                    label="nome"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Agência" label-for="dadoBancarioAgencia">
                <validation-provider #default="{ errors }" name="Agência" rules="required">
                  <cleave
                    id="dadoBancarioAgencia"
                    type="text"
                    placeholder="Agência"
                    v-model="dados.dadoBancarioAgencia"
                    maxlength="4"
                    :raw="false"
                    :options="options.cleaveAgencia"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="DV" label-for="dadoBancarioAgenciaDV">
                <validation-provider #default="{ errors }" name="Agencia DV" rules="required">
                  <b-form-input
                    id="dadoBancarioAgenciaDV"
                    type="text"
                    placeholder="DV"
                    v-model="dados.dadoBancarioAgenciaDV"
                    v-bloqueioCaractereMask="{ tamanho: 1, regex: /[^0-9A-Za-z]/ }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group label="Conta Corrente" label-for="dadoBancarioConta">
                <validation-provider #default="{ errors }" name="Conta Corrente" rules="required">
                  <b-form-input
                    id="dadoBancarioConta"
                    type="text"
                    placeholder="Conta Corrente"
                    v-model="dados.dadoBancarioConta"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Conta Corrente DV" label-for="dadoBancarioContaDV">
                <validation-provider #default="{ errors }" name="Conta Corrente DV" rules="required">
                  <b-form-input
                    id="dadoBancarioContaDV"
                    type="text"
                    placeholder="Conta Corrente DV"
                    v-model="dados.dadoBancarioContaDV"
                    v-bloqueioCaractereMask="{ tamanho: 1, regex: /[^0-9A-Za-z]/ }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="OP" label-for="dadoBancarioContaOP">
                <validation-provider #default="{ errors }" name="OP" rules="required">
                  <cleave
                    id="dadoBancarioContaOP"
                    type="text"
                    placeholder="OP"
                    v-model="dados.dadoBancarioContaOP"
                    maxlength="3"
                    :raw="false"
                    :options="options.cleaveOp"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Tipo de Conta" label-for="tipoDeConta">
                <validation-provider #default="{ errors }" name="Tipo de Conta" rules="required">
                  <v-select-pt
                    name="tipoDeConta"
                    v-model="dados.tipoDeConta"
                    :options="tipoDeConta"
                    :reduce="(option) => option.value"
                    label="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group label="Tipo de Chave Pix" label-for="tipoChavePix">
                <validation-provider #default="{ errors }" name="Tipo de Chave Pix" rules="required">
                  <v-select-pt
                    placeholder="Selecione"
                    name="tipoChavePix"
                    v-model="dados.tipoChavePix"
                    :options="tipoChavePixOpcoes"
                    :reduce="(option) => option.value"
                    label="text"
                    @input="dados.chavePix = ''"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group v-if="dados.tipoChavePix" label="Chave Pix" label-for="chavePix">
                <validation-provider #default="{ errors }" name="Chave Pix" rules="required">
                  <Cleave
                    v-if="dados.tipoChavePix === 'cpf'"
                    id="chavePix"
                    type="text"
                    placeholder="000.000.000-00"
                    v-model="dados.chavePix"
                    :raw="false"
                    :options="options.cleaveCPF"
                    class="form-control"
                    @input="removePontos"
                    @blur="validaCamposDocumentos((campo = dados.chavePix), 'chavePixCPF')"
                  />

                  <Cleave
                    v-else-if="dados.tipoChavePix === 'cnpj'"
                    id="chavePix"
                    type="text"
                    placeholder="00.000.000/0001-00"
                    v-model="dados.chavePix"
                    :raw="false"
                    :options="options.cleaveCNPJ"
                    class="form-control"
                    @input="removePontos"
                    @blur="validaCamposDocumentos((campo = dados.chavePix), 'chavePixCNPJ')"
                  />

                  <cleave
                    v-else-if="dados.tipoChavePix == 'email'"
                    id="chavePix"
                    type="email"
                    placeholder="exemplo@exemplo.com"
                    v-model="dados.chavePix"
                    :options="options.cleaveEmail"
                    :raw="false"
                    class="form-control"
                    @blur="validaCamposDocumentos((campo = dados.chavePix), 'chavePixEMAIL')"
                  />

                  <cleave
                    v-else-if="dados.tipoChavePix == 'telefone'"
                    id="chavePix"
                    type="tel"
                    placeholder="(99) 9 9999-9999"
                    v-model="dados.chavePix"
                    :raw="false"
                    :options="options.cleavePhone"
                    class="form-control"
                    @input="removePontos"
                    @blur="validaCamposDocumentos((campo = dados.chavePix), 'chavePixTELEFONE')"
                  />

                  <b-form-input v-else id="chavePix" type="text" placeholder="Chave aleatória" v-model="dados.chavePix" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
      </validation-observer>

      <!-- Segurado/Beneficiário -->
      <b-tab :disabled="!isEditing">
        <template #title>
          <feather-icon icon="UsersIcon" />
          <span>Segurado/Beneficiário</span>
        </template>

        <ValidationObserver ref="formularioSegurado">
          <b-row>
            <b-col md="4">
              <b-form-group label="Matrícula" label-for="matricula">
                <validation-provider #default="{ errors }" name="Matrícula" rules="required">
                  <b-form-input id="matricula" type="text" placeholder="Matrícula" v-model="segurado.matricula" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Órgão" label-for="orgao">
                <validation-provider #default="{ errors }" name="Órgão" rules="required">
                  <v-select-pt
                    name="orgao"
                    v-model="segurado.orgao"
                    :options="orgao"
                    :reduce="(option) => option.id"
                    label="nome"
                    @option:selected="limpaGrupoFolha"
                    @search:blur="carregarGrupoFolha"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Grupo Folha" label-for="grupoFolha">
                <validation-provider #default="{ errors }" name="Grupo Folha" rules="required">
                  <v-select-pt
                    name="grupoFolha"
                    v-model="segurado.grupoFolhaId"
                    :disabled="!segurado.orgao"
                    :options="gruposFolha"
                    :reduce="(option) => option.id"
                    label="nomeDoGrupo"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Remuneração (R$)" label-for="remuneracao">
                <validation-provider #default="{ errors }" name="Remuneração" rules="required">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text">R$</span>
                    </b-input-group-prepend>
                    <b-form-input
                      id="remuneracao"
                      v-number="number"
                      type="text"
                      v-model="segurado.remuneracao"
                      placeholder="Remuneração (R$)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Margem Utilizada (R$)" label-for="margemUtilizada">
                <validation-provider #default="{ errors }" name="Margem Utilizada" rules="required">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text">R$</span>
                    </b-input-group-prepend>
                    <b-form-input
                      id="margemUtilizada"
                      v-number="number"
                      type="text"
                      v-model="segurado.margemUtilizada"
                      placeholder="Margem Utilizada (R$)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Margem Disponível (R$)" label-for="margemDisponivel">
                <validation-provider #default="{ errors }" name="Margem Disponível" rules="required">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text">R$</span>
                    </b-input-group-prepend>
                    <b-form-input
                      id="margemDisponivel"
                      v-number="number"
                      type="text"
                      v-model="segurado.margemDisponivel"
                      placeholder="Margem Disponível (R$)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Categoria" label-for="categoria">
                <validation-provider #default="{ errors }" name="Categoria" rules="required">
                  <b-form-select name="categoria" v-model="segurado.categoria" :options="categoriaOpcoes"></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="auto" v-if="segurado.categoria == 'Pensionista'">
              <b-form-group label="É Vitalício?" label-for="ehVitalicio" id="divEhVitalicio">
                <b-form-checkbox
                  switch
                  id="ehVitalicio"
                  v-model="segurado.ehVitalicio"
                  name="ehVitalicio"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="segurado.categoria == 'Efetivo' || segurado.categoria == 'Estavel'">
              <b-form-group label="Data de Admissão" label-for="dataAdmissao">
                <validation-provider #default="{ errors }" name="Data de Admissão" rules="required">
                  <cleave
                    id="dataAdmissao"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    @blur="validaDataSegurado('dataAdmissao')"
                    v-model="segurado.dataAdmissao"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="(segurado.categoria == 'Efetivo' || segurado.categoria == 'Estavel') && segurado.id">
              <b-form-group label="Exonerado?" label-for="Exonerado" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Exonerado?" rules="required">
                  <b-form-radio-group
                    id="exonerado"
                    v-model="segurado.exonerado"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="segurado.exonerado">
              <b-form-group label="Data de Exoneração" label-for="dataExoneracao">
                <validation-provider
                  #default="{ errors }"
                  name="Data de Exoneração"
                  :rules="{
                    required: true,
                    dataPassada: {
                      value: segurado.dataExoneracao,
                      dataParametro: segurado.dataNascimento,
                      stringParametro: 'data de exoneração',
                    },
                  }"
                >
                  <b-input-group>
                    <cleave
                      ref="dataExoneracao"
                      id="dataExoneracao"
                      type="text"
                      v-model="segurado.dataExoneracao"
                      placeholder="DD/MM/AAAA"
                      class="form-control cleave-height"
                      :options="options.cleaveDate"
                      :raw="false"
                    />
                    <b-input-group-append>
                      <b-form-datepicker
                        button-variant="primary"
                        class="datePickerWithInput"
                        size="sm"
                        rounded="sm"
                        right
                        button-only
                        v-model="datePicker.dataExoneracao"
                        :hide-header="true"
                        :initial-date="new Date()"
                        :state="errors[0] ? false : null"
                        label-help=""
                        label-calendar="Calendário"
                        label-close-button="Fechar"
                        label-current-month="Mês atual"
                        label-next-decade="Próxima década"
                        label-next-month="Próximo mês"
                        label-next-year="Próximo ano"
                        label-prev-decade="Década anterior"
                        label-prev-month="Mês anterior"
                        label-prev-year="Ano anterior"
                        label-select-month="Selecione o mês"
                        label-select-year="Selecione o ano"
                        label-selected="Selecionado"
                        label-no-date-selected="Nenhuma data selecionada"
                        label-reset-button="Resetar"
                        label-today-button="Hoje"
                        label-today="Hoje"
                        locale="en"
                        :date-format-options="{ year: 'numeric', month: '2-digit', day: 'numeric' }"
                        aria-controls="dataExoneracao"
                      />
                    </b-input-group-append>
                  </b-input-group>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6" v-if="!portariaExoneracaoAnexada.id && segurado.exonerado && segurado.id">
              <div class="flex w-full items-center justify-center" id="app">
                <div class="p-12 bg-gray-100">
                  <validation-provider #default="{ errors }" name="Portaria de Exoneração" rules="required">
                    <b-form-group label="Portaria de Exoneração" label-for="portariaExoneracao">
                      <b-form-file
                        id="portariaExoneracao"
                        :state="Boolean(segurado.portariaExoneracao)"
                        ref="portariaExoneracaoFile"
                        accept=".pdf"
                        placeholder="Escolha um arquivo ou arraste até aqui ..."
                        drop-placeholder="Solte o arquivo aqui..."
                        browse-text="Escolher"
                        v-model="segurado.portariaExoneracao"
                      >
                      </b-form-file>
                    </b-form-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
              </div>
            </b-col>

            <b-col
              class="mr-0 pr-0"
              style="width: min-content"
              sm="12"
              md="4"
              v-if="portariaExoneracaoAnexada.id && segurado.exonerado && segurado.id"
            >
              <b-button class="w-100 mt-2" id="portariaExoneracao" variant="primary" @click="downloadPortariaExoneracaoAnexada">
                <span class="mr-05">Download Portaria de Exoneração </span>
                <feather-icon icon="DownloadIcon" size="14" />
              </b-button>
            </b-col>

            <b-col v-if="portariaExoneracaoAnexada.id && segurado.exonerado && segurado.id" md="auto">
              <b-button class="mt-2" variant="danger" @click="excluirPortariaExoneracaoAnexada">Excluir</b-button>
            </b-col>

            <b-col md="3" v-if="segurado.categoria == 'Aposentado' || segurado.categoria == 'Pensionista'">
              <b-form-group label="Data Início do Benefício" label-for="dataInicioBeneficio">
                <validation-provider #default="{ errors }" name="Data Início do Benefício" rules="required">
                  <cleave
                    id="dataInicioBeneficio"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    v-model="segurado.dataInicioBeneficio"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <!-- @blur="validaDataSegurado('dataInicioBeneficio')" -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="segurado.categoria == 'Aposentado'">
              <b-form-group label="Tipo de benefício" label-for="tipoBeneficio">
                <validation-provider #default="{ errors }" name="tipoBeneficio" rules="required">
                  <b-form-select
                    id="tipoBeneficio"
                    name="tipoBeneficio"
                    v-model="segurado.tipoBeneficio"
                    :options="beneficioOpcoes"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3" v-if="segurado.categoria == 'Pensionista' && segurado.ehVitalicio == false">
              <b-form-group label="Data Fim do Benefício" label-for="dataFimBeneficio">
                <validation-provider #default="{ errors }" name="Data Fim do Benefício" rules="required">
                  <cleave
                    id="dataFimBeneficio"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    @blur="validaDataSegurado('dataFimBeneficio')"
                    v-model="segurado.dataFimBeneficio"
                    :options="options.cleaveDate"
                    :raw="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="this.dados.id">
              <b-form-group label="Bloqueado judicialmente?" label-for="bloqueioJudicial" v-slot="{ ariaDescribedby }">
                <validation-provider #default="{ errors }" name="Bloqueado judicialmente" rules="required">
                  <b-form-radio-group
                    id="bloqueioJudicial"
                    v-model="segurado.bloqueioJudicial"
                    :options="optionsSimNao"
                    :aria-describedby="ariaDescribedby"
                    button-variant="outline-primary"
                    class="w-100"
                    name="radio-btn-outline"
                    buttons
                  ></b-form-radio-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="this.dados.id && segurado.bloqueioJudicial">
              <b-form-group label="Data da suspensão judicial" label-for="dataBloqueioJudicial">
                <validation-provider #default="{ errors }" name="Data da suspensão judicial" rules="required">
                  <cleave
                    id="dataBloqueioJudicial"
                    class="form-control"
                    type="text"
                    placeholder="DD/MM/AAAA"
                    @blur="validaDataSegurado('dataBloqueioJudicial')"
                    v-model="segurado.dataBloqueioJudicial"
                    :options="options.cleaveDate"
                    :raw="false"
                  />

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Profissão" label-for="profissao">
                <validation-provider #default="{ errors }" name="Profissao" rules="required">
                  <v-select-pt
                    name="ClassificacaoBrasileiraOcupacoes"
                    v-model="segurado.profissaoId"
                    :options="cbo"
                    :reduce="(option) => option.id"
                    label="nomeCargo"
                  ></v-select-pt>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="3" v-show="segurado.profissaoId == profissaoOutros">
              <b-form-group label="Profissão (Especificar)" label-for="profissaoOutros">
                <validation-provider
                  #default="{ errors }"
                  name="Profissão (Especificar)"
                  :rules="{ required: segurado.profissaoId == profissaoOutros }"
                >
                  <b-form-input
                    id="profissaoOutros"
                    type="text"
                    placeholder="Digite a profissão"
                    v-model="segurado.profissaoOutros"
                    v-on:keypress="isLetter($event)"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="CNPJ da Instituição" label-for="CNPJInstituicao">
                <validation-provider #default="{ errors }" name="CNPJ da Instituicao" rules="cnpj">
                  <cleave
                    id="CNPJInstituicao"
                    name="CNPJInstituicao"
                    type="text"
                    placeholder="Digite o CNPJ"
                    v-model="segurado.CNPJInstituicao"
                    :raw="false"
                    :options="options.cleaveCNPJ"
                    class="form-control"
                    @input="removePontos"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="Valor do Patrimônio (R$)" label-for="ValorPatrimonio">
                <validation-provider #default="{ errors }" name="Valor do Patrimonio" rules="required">
                  <b-input-group>
                    <b-input-group-prepend>
                      <span class="input-group-text">R$</span>
                    </b-input-group-prepend>
                    <b-form-input
                      id="ValorPatrimonio"
                      v-number="number"
                      type="text"
                      v-model="segurado.ValorPatrimonio"
                      placeholder="Valor do Patrimonio (R$)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </ValidationObserver>

        <!-- Actions -->
        <b-row>
          <b-col md="4">
            <b-form-group label=" " label-for="btnEraseFormSegurado">
              <b-button
                name="btnCreateEditSegurado"
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="primary"
                @click="createEditSegurado()"
              >
                {{ isCreateSegurado ? 'Cadastrar' : 'Salvar' }}
              </b-button>
              <b-button
                name="btnEraseFormSegurado"
                class="ml-1"
                v-ripple.400="'rgba(40, 74, 199, 0.4)'"
                variant="secondary"
                @click="eraseFormSegurado()"
              >
                Limpar
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-table striped :items="tomadorSegurados" :fields="fieldsTableSegurados">
            <template #cell(opcoes)="row">
              <b-dropdown variant="link" no-caret toggle-class="p-0" left :popper-opts="{ positionFixed: true }">
                <template #button-content>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon"
                    title="Este botão contém as opções disponíveis para este registro"
                  >
                    <feather-icon icon="SettingsIcon" />
                  </b-button>
                </template>
                <b-dropdown-item @click="editarSegurado(row.item)">
                  <feather-icon icon="EditIcon" size="16" />
                  <span class="align-middle ml-50">Editar</span>
                </b-dropdown-item>
                <b-dropdown-item @click="excluirSegurado(row.item.id)">
                  <feather-icon icon="XIcon" size="16" />
                  <span class="align-middle ml-50">Excluir</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>

            <template #cell(margemDisponivel)="row">
              {{ formatarValor(Number(row.item.margemDisponivel)) }}
            </template>

            <template #cell(remuneracao)="row">
              {{ formatarValor(Number(row.item.remuneracao)) }}
            </template>
          </b-table>
        </b-row>
      </b-tab>
    </b-tabs>

    <b-modal id="modal-foto" ref="modal-foto" centered size="lg" title="Captura de Foto" hide-footer no-close-on-backdrop>
      <div class="camera-canvas">
        <video v-if="isCameraOpen" ref="camera" :width="canvasWidth" :height="canvasHeight" autoplay></video>
        <canvas v-show="!isCameraOpen" ref="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
      </div>

      <template>
        <b-button size="sm" variant="primary" v-show="isCameraOpen" @click="capture()"> Tirar Foto </b-button>
        <b-button size="sm" variant="success" v-show="!isCameraOpen" @click="confirmarFoto()" :disabled="loading">
          Confirmar Foto
        </b-button>
        <b-button size="sm" class="ml-1" variant="danger" @click="toggleCamera()" v-show="!isCameraOpen">
          Limpar Foto
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { cep, email, rule_cep, telefone } from '@/@core/utils/validations/validations'
  import useJwt from '@/auth/jwt/useJwt'
  import {
    Ufs,
    formatarData,
    formatarDataGlobal,
    formatarParaNumber,
    formatarTipoDate,
    formatarValor,
    isCPFValid,
    isLetter,
    isNumber,
    toNumeric,
    validaCNPJ,
    validaRG,
    validarCnpj,
    validarData,
    validarEmail,
    validarTelefone,
  } from '@/libs/utils'
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  import { dataFutura, dataPassada, minLength, regex, required } from '@validations'
  import 'cleave.js/dist/addons/cleave-phone.br'
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import Cleave from 'vue-cleave-component'
  import Ripple from 'vue-ripple-directive'
  import { VueSelect } from 'vue-select'

  export default {
    components: {
      minLength,
      BCardCode,
      ValidationProvider,
      ValidationObserver,
      formatarData,
      formatarDataGlobal,
      isNumber,
      toNumeric,
      validarData,
      Cleave,
      formatarValor,
      VueSelect,
      dataPassada,
      regex,
      dataFutura,
      validaRG,
      validaCNPJ,
      formatarTipoDate,
      telefone,
      email,
      cep,
      rule_cep,
    },
    directives: {
      Ripple,
    },
    props: {
      parametro: {},
      isEditing: true,
    },
    data() {
      return {
        required,
        isLetter,
        isCPFValid,
        isNumber,
        toNumeric,
        validarData,
        formatarValor,
        dataPassada,

        beneficioOpcoes: [
          { value: 'aposentadoriaPorIncapacidadePermanente', text: 'Aposentadoria por Incapacidade Permanente' },
          { value: 'aposentadoriaPorTempoDeContribuição', text: 'Aposentadoria por Tempo de Contribuição' },
          { value: 'aposentadoriaCompulsoria', text: 'Aposentadoria Compulsória' },
          { value: 'aposentadoriaPorIdade', text: 'Aposentadoria por Idade' },
          { value: 'aposentadoriaPorTempoDeServico', text: 'Aposentadoria por Tempo de Serviço' },
        ],
        userData: this.$jwtDecode(localStorage.getItem('userData')).userData,
        isBusy: true,
        pesquisar: {
          tipoOpcoes: 1,
          descricao: '',
          perPage: 25,
          currentPage: 1,
        },
        loading: false,
        isCreateSegurado: true,
        number: 0.0,
        canvasHeight: 255,
        canvasWidth: 340,
        isCameraOpen: false,
        tipoOpcoes: [
          { value: 1, text: 'Nome' },
          { value: 2, text: 'CPF' },
          { value: 3, text: 'Matrícula' },
        ],
        tipoDeConta: [
          { value: 'contaCorrente', text: 'Conta Corrente' },
          { value: 'contaPoupanca', text: 'Conta Poupança' },
          { value: 'contaSalario', text: 'Conta Salário' },
          { value: 'contaUniversitaria', text: 'Conta Universitária' },
          { value: 'contaDigital', text: 'Conta Digital' },
          { value: 'contaConjunta', text: 'Conta Conjunta' },
          { value: 'contaEmpresarial', text: 'Conta Empresarial' },
          { value: 'contaPagamento', text: 'Conta de Pagamento' },
          { value: 'contaRemunerada', text: 'Conta Remunerada' },
        ],
        tipoChavePixOpcoes: [
          { value: 'cpf', text: 'CPF' },
          { value: 'cnpj', text: 'CNPJ' },
          { value: 'email', text: 'E-mail' },
          { value: 'telefone', text: 'Telefone' },
          { value: 'aleatoria', text: 'Aleatória' },
        ],
        sexoOpcoes: [
          { value: '', text: 'Selecione' },
          { value: 'M', text: 'Masculino' },
          { value: 'F', text: 'Feminino' },
        ],
        generoOpcoes: [
          { value: '', text: 'Selecione' },
          { value: 'T', text: 'Transgênero' },
          { value: 'C', text: 'Cisgênero' },
          { value: 'N', text: 'Não-Binário' },
        ],
        estadoCivilOpcoes: [
          { value: '', text: 'Selecione' },
          { value: 'Solteiro(a)', text: 'Solteiro(a)' },
          { value: 'Casado(a)', text: 'Casado(a)' },
          { value: 'Separado(a)', text: 'Separado(a)' },
          { value: 'Divorciado(a)', text: 'Divorciado(a)' },
          { value: 'Viúvo(a)', text: 'Viúvo(a)' },
        ],
        excluirSegurados: [],
        tomadorSegurados: [],
        nacionalidade: [],
        banco: [],
        clientes: [],
        cidadeNaturalidade: [],
        cidadeEndereco: [],
        ufOpcoes: Ufs,
        ufOpcoes2: Ufs,
        profissaoOutros: 2695,
        orgao: [],
        cbo: [],
        categoriaOpcoes: [
          { value: '', text: 'Selecione' },
          { value: 'Efetivo', text: 'Efetivo' },
          { value: 'Estavel', text: 'Estável' },
          { value: 'Pensionista', text: 'Pensionista' },
          { value: 'Aposentado', text: 'Aposentado' },
        ],
        options: {
          cleaveCPF: {
            delimiters: ['.', '.', '-'],
            blocks: [3, 3, 3, 2],
            numericOnly: true,
          },
          cleaveEmail: {
            blocks: [100],
          },
          cleaveCNPJ: {
            delimiters: ['.', '.', '/', '-'],
            numericOnly: true,
            blocks: [2, 3, 3, 4, 2],
          },
          cleaveRG: {
            blocks: [25],
          },
          cleaveDate: {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y'],
          },
          cleavePhone: {
            numericOnly: true,
            delimiters: ['(', ')', ' ', '-'],
            blocks: [0, 2, 0, 5, 4],
          },
          cleaveCEP: {
            delimiters: ['-'],
            blocks: [5, 3],
          },
          cleaveCnh: {
            blocks: [11],
            numericOnly: true,
          },
          cleaveAgencia: {
            numericOnly: true,
            blocks: [4],
          },
          cleaveOp: {
            blocks: [3],
          },
        },
        optionsSimNao: [
          { text: 'Sim', value: true },
          { text: 'Não', value: false },
        ],
        pageOptions: [25, 50, 100],
        totalRows: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        cleaveCurrency: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          delimiter: '.',
          numeralDecimalMark: ',',
          numeralDecimalScale: 2,
        },
        fieldsTableSegurados: [
          { key: 'opcoes', label: 'OPÇÕES' },
          { key: 'matricula', label: 'Matrícula' },
          {
            key: 'situacaoPrevidenciaria',
            label: 'Categoria',
          },
          { key: 'margemDisponivel', label: 'Margem Disponível' },
          { key: 'remuneracao', label: 'Remuneração' },
          { key: 'orgao.nome', label: 'Órgão' },
        ],
        fields: [
          {
            key: 'opcoes',
            label: 'Opções',
          },
          {
            key: 'avatar',
            label: '',
          },
          { key: 'nomeCompleto', label: 'Nome', sortable: true },
          { key: 'cpf', label: 'CPF', sortable: true },
          {
            key: 'dataNascimento',
            label: 'Data Nascimento',
            sortable: true,
            formatter: (value, key, item) => {
              return formatarData(value)
            },
          },
          'sexo',
          { key: 'matricula', label: 'Matrícula', sortable: true },
          { key: 'orgao.nome', label: 'Orgão', sortable: true },
          'categoria',
        ],
        items: [],
        acesso: {},
        segurado: {
          categoria: '',
          ehVitalicio: false,
          remuneracao: null,
          margemDisponivel: null,
          margemUtilizada: null,
          dataAdmissao: '',
          dataInicioBeneficio: '',
          dataFimBeneficio: '',
          orgao: null,
          ordaoId: null,
          grupoFolhaId: null,
          tipoBeneficio: null,
          exonerado: false,
          dataExoneracao: '',
          bloqueioJudicial: false,
          dataBloqueioJudicial: '',
          profissaoId: '',
          profissaoOutros: '',
          CNPJInstituicao: '',
          ValorPatrimonio: '',
        },
        listaSegurados: [],
        dados: {
          foto: null,
          nacionalidade: 76,
          sexo: '',
          genero: '',
          portadorMolestiaGrave: false,
          portadorDoencaIncapacitante: false,
          falecido: false,
          exonerado: false,
          dataExoneracao: '',
          tipoChavePix: '',
          chavePix: '',
          categoria: '',
          naturalidade: '',
          cpfConjuge: '',
          nomeConjuge: '',
          ClassificacaoBrasileiraOcupacoes: '',
          profissaoOutros: '',
          ValorPatrimonio: '',

          cidadeEndereco: {
            nome: null,
          },
          rgUF: '',
          ufNaturalidade: '',
          estadoCivil: '',
          dadoBancarioAgencia: '',
          dadoBancarioAgenciaDV: '',
          domicilioFiscaoEUA: false,
          possuiParentePPE: false,
          tomadorPPE: false,
          possuiCNH: false,
          cnhNumero: '',
          orgaoExpedidorCNH: '',
          cnhCategoria: '',
          cnhDataExpedicao: '',
          cnhDataValidade: '',
          CNPJInstituicao: '',

          paisResidenciaEnderecoEstrangeiro: 'Brasil',
          cidadeResidenciaEnderecoEstrangeiro: '',
          estadoProvinciaEnderecoEstrangeiro: '',
          enderecoEstrangeiro: '',
          codigoPostalEnderecoEstrangeiro: '',
          numeroEnderecoEstrangeiro: '',
          complementoEnderecoEstrangeiro: '',
        },
        optionsCnhCategorias: [
          { label: 'A', id: 'A' },
          { label: 'B', id: 'B' },
          { label: 'C', id: 'C' },
          { label: 'D', id: 'D' },
          { label: 'E', id: 'E' },
          { label: 'ACC', id: 'ACC' },
        ],
        certidaoObitoAnexada: null,
        portariaExoneracaoAnexada: {
          id: null,
        },
        tomadorWithOrg: {},
        categoria: [
          {
            Ativo: 'primary',
            Aposentado: 'light-success',
            Pensionista: 'light-danger',
          },
        ],
        gruposFolha: [],
        datePicker: {
          dataObito: '',
        },
        orgaosEmissores: [
          { value: 'SSP', text: 'SSP – Secretaria de Segurança Pública (estado de emissão)' },
          { value: 'DETRAN', text: 'DETRAN – Departamento Estadual de Trânsito' },
          { value: 'IFP', text: 'IFP – Instituto de Identificação Félix Pacheco (RJ)' },
          {
            value: 'CGPI/DIREX/DPF',
            text: 'CGPI/DIREX/DPF – Coordenação-Geral de Polícia de Imigração/Departamento de Polícia Federal',
          },
          { value: 'PM', text: 'PM – Polícia Militar (exclusivo para militares)' },
          { value: 'EB', text: 'EB – Exército Brasileiro (exclusivo para militares)' },
          { value: 'FAB', text: 'FAB – Força Aérea Brasileira (exclusivo para militares)' },
          { value: 'MEX', text: 'MEX – Marinha do Brasil (exclusivo para militares)' },
          { value: 'OAB', text: 'OAB – Ordem dos Advogados do Brasil (para advogados)' },
          { value: 'CRA', text: 'CRA – Conselho Regional de Administração (para administradores)' },
          { value: 'CRM', text: 'CRM – Conselho Regional de Medicina (para médicos)' },
          { value: 'CREA', text: 'CREA – Conselho Regional de Engenharia e Agronomia (para engenheiros)' },
          { value: 'CRF', text: 'CRF – Conselho Regional de Farmácia (para farmacêuticos)' },
          {
            value: 'OUTROS',
            text: 'OUTROS – Caso específico de órgãos regionais ou categorias profissionais legalmente aceitos',
          },
        ],
      }
    },
    watch: {
      dados: {
        handler: function (val, oldVal) {
          if (val.dataObito?.length == 10) {
            this.datePicker.dataObito = formatarData(val.dataObito)
          }
        },
        deep: true,
      },

      datePicker: {
        handler: function (val, oldVal) {
          if (val.dataObito) {
            this.dados.dataObito = this.formatarDataISO(val.dataObito)
          }

          if (val.dataExoneracao) {
            this.segurado.dataExoneracao = formatarData(val.dataExoneracao)
          }
        },
        deep: true,
      },

      'segurado.ehVitalicio': function (val) {
        if (val) {
          this.segurado.dataFimBeneficio = ''
        }
      },
    },
    computed: {
      sortOptions() {
        return this.fields.filter((f) => f.sortable).map((f) => ({ text: f.label, value: f.key }))
      },
    },
    async mounted() {
      if (this.userData.role == 'master') {
        this.acesso.CadastroTomadorEditar = true
      } else {
        this.acesso.CadastroTomadorEditar = this.userData.GrupoAcesso.CadastroTomadorEditar
      }
      this.carregarPaises()
      this.carregarOrgaos()
      this.carregarBancos()
      this.carregarClientes()
      this.carregarCBO()
      if (this.parametro) {
        await this.editar(this.parametro.id)
      }
    },
    methods: {
      removePontos() {
        // Remove pontos da string
        this.dados.chavePix = this.dados.chavePix.replace(/[./( )-]/g, '')
      },
      buscarCEP() {
        if (rule_cep(this.dados.cepEndereco)) {
          let dadosPesquisaCep = {
            cep: this.dados.cepEndereco.replace(/\D/g, ''),
            tomadorId: this.dados.id ? this.dados.id : null,
          }

          useJwt
            .post(`cadastro/tomador/GetBuscaCepTomador`, dadosPesquisaCep)
            .then(async (response) => {
              if (response.data.status) {
                if (response.data.status == 'erro') this.$message.error(response.data.mensagem)
              } else {
                await this.carregarCidadeEndereco(response.data.uf)
                this.dados = {
                  ...this.dados,
                  complemento: response.data.complemento,
                  logradouroEndereco: response.data.logradouro,
                  bairroEndereco: response.data.bairro,
                  ufEndereco: response.data.uf,
                  cidadeEndereco: response.data.localidade,
                }
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      },
      async carregarCidadeEndereco(item) {
        return new Promise((resolve, reject) => {
          useJwt
            .get(`utils/cidades/${item}`)
            .then((response) => {
              this.cidadeEndereco = response.data
              return resolve(response.data)
            })
            .catch((error) => {
              console.error(error)
              return reject()
            })
        })
      },
      carregarGrupoFolha() {
        let orgaoId = this.segurado?.orgao?.id || this.segurado?.orgao
        if (orgaoId)
          useJwt
            .pesquisar('cadastro/grupoFolha/GetPesquisarPorOrgao', {
              orgaoId: orgaoId,
            })
            .then((response) => {
              this.gruposFolha = response.data
            })
            .catch((error) => {
              console.error(error)
            })
      },
      async carregarCidadeNaturalidade(novaUf) {
        // Limpar naturalidade e as opções atuais
        this.dados.naturalidade = null
        this.cidadeNaturalidade = []

        if (novaUf) {
          try {
            // Fazer a chamada para carregar as cidades
            const resultado = await useJwt.get(`utils/cidades/${novaUf}`)
            this.cidadeNaturalidade = resultado.data // Atualizar as opções disponíveis
            return resultado.data
          } catch (error) {
            console.error('Erro ao carregar cidades:', error)
          }
        }
      },
      limparValoresEstado() {
        this.dados.naturalidade = ''
        this.carregarCidadeNaturalidade(this.dados.ufNaturalidade)
      },
      carregarPaises() {
        useJwt
          .get('utils/paises')
          .then((response) => {
            this.nacionalidade = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },
      carregarBancos() {
        useJwt
          .get('utils/bancos')
          .then((response) => {
            this.banco = response.data
            this.banco.forEach((banco) => {
              if (banco.codigo) banco.nome = String(banco.codigo) + ' - ' + String(banco.nome)
            })
          })
          .catch((error) => {
            console.error(error)
          })
      },
      carregarOrgaos(institutoId) {
        useJwt
          .get(`cadastro/orgao`)
          .then((response) => {
            this.orgao = response.data.filter((orgao) => orgao.institutoId === institutoId)
          })
          .catch((error) => {
            console.error(error)
          })
      },
      carregarCBO() {
        useJwt
          .get(`utils/GetCBO`)
          .then((response) => {
            this.cbo = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },
      async editar(item) {
        if (item)
          useJwt
            .edit(`cadastro/tomador`, item)
            .then(async (response) => {
              this.dados = {
                ...response.data,
                dataNascimento: response.data.dataNascimento ? formatarData(response.data.dataNascimento) : '',
                rgDataEmissao: response.data.rgDataEmissao ? formatarData(response.data.rgDataEmissao) : '',
                dataAdmissao: response.data.dataAdmissao ? formatarData(response.data.dataAdmissao) : '',
                dataFimBeneficio: response.data.dataFimBeneficio ? formatarData(response.data.dataFimBeneficio) : '',
                portadorMolestiaGrave: response.data.portadorMolestiaGrave ? true : false,
                portadorDoencaIncapacitante: response.data.portadorDoencaIncapacitante ? true : false,
                falecido: response.data.falecido ? true : false,
                dataObito: response.data.dataObito ? formatarData(response.data.dataObito) : '',
                tipoChavePix: response.data.tipoChavePix ? response.data.tipoChavePix : '',
                chavePix: response.data.chavePix ? response.data.chavePix : '',
                domicilioFiscaoEUA: response.data.domicilioFiscaoEUA ? response.data.domicilioFiscaoEUA : false,
                possuiParentePPE: response.data.possuiParentePPE ? response.data.possuiParentePPE : false,
                tomadorPPE: response.data.tomadorPPE ? response.data.tomadorPPE : false,
                possuiCNH: response.data.possuiCNH ? response.data.possuiCNH : false,
                cnhDataExpedicao: response.data.cnhDataExpedicao ? formatarData(response.data.cnhDataExpedicao) : '',
                cnhDataValidade: response.data.cnhDataValidade ? formatarData(response.data.cnhDataValidade) : '',
                nomeConjuge: response.data.nomeConjuge ? response.data.nomeConjuge : '',
                cpfConjuge: response.data.cpfConjuge ? response.data.cpfConjuge : '',
              }
              this.dados.paisResidenciaEnderecoEstrangeiro = this.dados.paisResidenciaEnderecoEstrangeiro ?? 'Brasil'
              const institutoId = response.data.institutoId
              if (institutoId) {
                this.carregarOrgaos(institutoId)
              }
              if (this.dados.certidaoObito) {
                this.certidaoObitoAnexada = this.dados.certidaoObito
              }

              this.tomadorSegurados = response.data.segurado

              if (response.data.paisId) {
                this.dados.nacionalidade = this.nacionalidade.find((pais) => pais.codigoFederal == response.data.paisId)
              }
              if (this.dados.ufNaturalidade) {
                await this.carregarCidadeNaturalidade(this.dados.ufNaturalidade)
                this.dados.naturalidade = this.cidadeNaturalidade.find(
                  (cidade) => cidade.nome == response.data.naturalidade,
                )?.nome
              }

              if (this.dados.ufEndereco) {
                this.carregarCidadeEndereco(this.dados.ufEndereco).then((resultado) => {
                  this.dados.cidadeEndereco = resultado.find((cidade) => cidade.nome == response.data.cidadeEndereco)?.nome
                })
              }
            })
            .catch((error) => {
              console.error(error)
            })
      },
      async salvar() {
        const invalid = !(await this.$refs['formDadosCadastraisEnderecoBancarios'].validate())
        if (invalid) {
          this.$message.error('Preencha todos os campos obrigatórios!')
          return
        }

        if (this.segurado.id) {
          this.$message.error('Existe uma edição de segurado pendente de finalização!')
          return
        }

        this.loading = true
        let dadosInsert = {
          ...this.dados,
          dataNascimento: this.dados.dataNascimento ? formatarDataGlobal(this.dados.dataNascimento) : null,
          rgDataEmissao: this.dados.rgDataEmissao ? formatarDataGlobal(this.dados.rgDataEmissao) : null,
          dataAdmissao: this.dados.dataAdmissao ? formatarDataGlobal(this.dados.dataAdmissao) : null,
          dataFimBeneficio: this.dados.dataFimBeneficio ? formatarDataGlobal(this.dados.dataFimBeneficio) : null,
          naturalidade: this.dados.naturalidade,
          cidadeEndereco: this.dados.cidadeEndereco,
          nacionalidade: this.dados.nacionalidade,
          institutoId: this.dados.institutoId,
          tipoChavePix: this.dados.tipoChavePix,
          chavePix: this.dados.chavePix,
        }

        if (this.dados.certidaoObito) this.insereCertidaoObito()

        const { foto, ...dados } = dadosInsert

        if (!this.dados.id) {
          useJwt
            .post('cadastro/tomador', dados)
            .then((response) => {
              if (this.dados.foto) {
                useJwt
                  .post(`cadastro/tomador/cadastrarFoto`, {
                    foto: this.dados.foto.foto,
                    tomadorId: response.data.id,
                  })
                  .then((response) => {
                    this.loading = false
                    this.$emit('atualizaGrid')
                    this.mostrarMsgModal('Cadastrado com sucesso!')
                  })
                  .catch((error) => {
                    console.error(error)
                  })
              } else {
                this.mostrarMsgModal('Cadastrado com sucesso!')
              }
            })
            .catch((error) => {
              console.error(error)
              if (error.response?.status === 422) {
                this.$message.error('Este CPF já está cadastrado na unidade gestora')
                return
              }
              this.$message.error('Houve um erro ao cadastrar o tomador')
            })
        } else {
          useJwt
            .update(`cadastro/tomador`, this.dados.id, dados)
            .then((response) => {
              this.$emit('atualizaGrid')
              this.mostrarMsgModal('Registro alterado com sucesso!')
            })
            .catch((error) => {
              if (error.response?.status === 422) {
                this.$message.error('Este CPF já está cadastrado na unidade gestora')
                return
              }
              this.$message.error('Houve um erro ao alterar o tomador')
            })
        }
      },
      mostrarMsgModal(titulo) {
        this.$swal({
          title: 'Atenção!',
          text: titulo,
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.$emit('tomadorLoadingEvent', !this.loading)
          }
        })
      },
      capturarFoto() {
        this.toggleCamera()
        this.$refs['modal-foto'].show()
      },
      toggleCamera() {
        this.isCameraOpen = true
        this.startCameraStream()
      },
      startCameraStream() {
        const constraints = (window.constraints = {
          audio: false,
          video: true,
        })
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            this.$refs.camera.srcObject = stream
          })
          .catch((error) => {
            console.error(error)
            this.$message.error('Desculpe mas seu navegador não tem suporte para capturar foto!')
          })
      },
      stopCameraStream() {
        let tracks = this.$refs.camera.srcObject.getTracks()
        tracks.forEach((track) => {
          track.stop()
        })
      },
      capture() {
        const FLASH_TIMEOUT = 50
        let self = this
        setTimeout(() => {
          const context = self.$refs.canvas.getContext('2d')
          context.drawImage(self.$refs.camera, 0, 0, self.canvasWidth, self.canvasHeight)
          const dataUrl = self.$refs.canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
          self.isCameraOpen = false
          self.stopCameraStream()
        }, FLASH_TIMEOUT)
      },
      limparFoto() {
        this.$swal({
          title: 'Atenção!',
          text: 'Deseja realmente limpar a foto?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim!',
          cancelButtonText: 'Não!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            useJwt
              .delete(`cadastro/tomador/limparFoto`, this.dados.id)
              .then((response) => {
                this.dados = { ...this.dados, foto: null }
              })
              .catch((error) => {
                console.error(error)
              })
          }
        })
      },
      confirmarFoto() {
        this.loading = true
        let self = this
        const dataUrl = self.$refs.canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')

        if (this.dados.id) {
          useJwt
            .post(`cadastro/tomador/cadastrarFoto`, {
              foto: dataUrl,
              tomadorId: this.dados.id,
            })
            .then((response) => {
              this.dados = { ...this.dados, foto: response.data }
              this.$message.success('Foto capturada com sucesso!')
              this.loading = false
              this.$refs['modal-foto'].hide()
            })
            .catch((error) => {
              this.loading = false
              console.error(error)
            })
        } else {
          this.dados = { ...this.dados, foto: { foto: dataUrl } }
          this.$message.success('Foto capturada com sucesso!')
          this.loading = false
          this.$refs['modal-foto'].hide()
        }
      },
      apresentaCortarFoto() {
        this.$refs['modal-editar-foto'].hide()
      },
      createEditSegurado() {
        this.$refs.formularioSegurado.validate().then((success) => {
          if (success) {
            if (this.segurado.exonerado && this.dados.falecido) {
              this.$message.error('Um tomador falecido não pode ser exonerado!')
              return
            }

            let orgao = undefined
            if (this.segurado.orgao) {
              if (this.segurado.orgao.id) orgao = this.orgao.find((orgao) => orgao.id == this.segurado.orgao.id)
              else orgao = this.orgao.find((orgao) => orgao.id == this.segurado.orgao)
            }

            let dadosFormSegurado = {
              id: this.segurado.id ? this.segurado.id : null,
              matricula: this.segurado.matricula,
              orgao: orgao,
              orgaoId: orgao.id,
              situacaoPrevidenciaria: this.segurado.categoria,
              remuneracao: formatarParaNumber(this.segurado.remuneracao),
              margemUtilizada: formatarParaNumber(this.segurado.margemUtilizada),
              margemDisponivel: formatarParaNumber(this.segurado.margemDisponivel),
              ehVitalicio: this.segurado.ehVitalicio,
              grupoFolhaId: this.segurado.grupoFolhaId,
              tipoBeneficio: this.segurado.tipoBeneficio,
              portadorMolestiaGrave: this.segurado.portadorMolestiaGrave,
              portadorDoencaIncapacitante: this.segurado.portadorDoencaIncapacitante,
              exonerado: this.segurado.exonerado,
              bloqueioJudicial: this.segurado.bloqueioJudicial,

              dataAdmissao: this.segurado.dataAdmissao
                ? String(this.segurado.dataAdmissao).split('/').reverse().join('-')
                : null,
              dataInicioBeneficio: this.segurado.dataInicioBeneficio
                ? String(this.segurado.dataInicioBeneficio).split('/').reverse().join('-')
                : null,
              dataFimBeneficio: this.segurado.dataFimBeneficio
                ? String(this.segurado.dataFimBeneficio).split('/').reverse().join('-')
                : null,
              dataExoneracao: this.segurado.dataExoneracao
                ? String(this.segurado.dataExoneracao).split('/').reverse().join('-')
                : null,
              dataBloqueioJudicial: this.segurado.dataBloqueioJudicial
                ? String(this.segurado.dataBloqueioJudicial).split('/').reverse().join('-')
                : null,

              profissaoId: this.segurado.profissaoId ? this.segurado.profissaoId : '',
              profissaoOutros: this.segurado.profissaoOutros ? this.segurado.profissaoOutros : '',
              CNPJInstituicao: this.segurado.CNPJInstituicao ? this.segurado.CNPJInstituicao : '',
              ValorPatrimonio: this.segurado.ValorPatrimonio ? formatarParaNumber(this.segurado.ValorPatrimonio) * 100 : '',
            }

            // Atualiza essa linha abaixo!!!!!!!!!!!!!
            let nomeTomador = this.dados.nomeCompleto.split(' ')[0]
            // Cadastro de CRP Documento
            if (this.segurado.portariaExoneracao?.name) {
              const formData = new FormData()
              formData.append('nome', 'Portaria Exoneracao - ' + nomeTomador)
              formData.append('seguradoId', dadosFormSegurado.id)
              formData.append('institutoId', this.dados.institutoId)
              formData.append('file', this.segurado.portariaExoneracao)
              formData.append('fileName', this.segurado.portariaExoneracao.name)

              useJwt
                .postDocumento(`cadastro/tomador/uploadPortariaExoneracao`, () => {}, formData)
                .then((response) => {})
                .catch((error) => {
                  console.error('Erro ao salvar a portaria. Error: ' + error)
                })
            }

            let jaPossuiMatriculaNaGrid = false
            this.tomadorSegurados.forEach((rowSegurado) => {
              if (rowSegurado.matricula === dadosFormSegurado.matricula && rowSegurado.orgaoId === dadosFormSegurado.orgaoId) {
                jaPossuiMatriculaNaGrid = true
              }
            })

            if (!dadosFormSegurado.id && !jaPossuiMatriculaNaGrid) {
              this.tomadorSegurados.push(dadosFormSegurado)
            } else {
              this.tomadorSegurados.forEach((rowSegurado) => {
                if (
                  rowSegurado.id === dadosFormSegurado.id ||
                  (rowSegurado.matricula === dadosFormSegurado.matricula && rowSegurado.orgaoId === dadosFormSegurado.orgaoId)
                ) {
                  rowSegurado.matricula = dadosFormSegurado.matricula
                  rowSegurado.situacaoPrevidenciaria = dadosFormSegurado.situacaoPrevidenciaria
                  rowSegurado.remuneracao = dadosFormSegurado.remuneracao
                  rowSegurado.margemUtilizada = dadosFormSegurado.margemUtilizada
                  rowSegurado.margemDisponivel = dadosFormSegurado.margemDisponivel
                  rowSegurado.ehVitalicio = dadosFormSegurado.ehVitalicio
                  rowSegurado.grupoFolhaId = dadosFormSegurado.grupoFolhaId
                  rowSegurado.dataAdmissao = dadosFormSegurado.dataAdmissao
                  rowSegurado.dataInicioBeneficio = dadosFormSegurado.dataInicioBeneficio
                  rowSegurado.dataFimBeneficio = dadosFormSegurado.dataFimBeneficio
                  rowSegurado.orgaoId = dadosFormSegurado.orgao.id
                  rowSegurado.orgao = dadosFormSegurado.orgao
                  rowSegurado.tipoBeneficio = dadosFormSegurado.tipoBeneficio
                  rowSegurado.exonerado = dadosFormSegurado.exonerado
                  rowSegurado.dataExoneracao = formatarData(dadosFormSegurado.dataExoneracao)
                  rowSegurado.bloqueioJudicial = dadosFormSegurado.bloqueioJudicial
                  rowSegurado.dataBloqueioJudicial = formatarData(dadosFormSegurado.dataBloqueioJudicial)
                  rowSegurado.profissaoId = dadosFormSegurado.profissaoId
                  rowSegurado.profissaoOutros = dadosFormSegurado.profissaoOutros
                  rowSegurado.CNPJInstituicao = dadosFormSegurado.CNPJInstituicao
                  rowSegurado.ValorPatrimonio = dadosFormSegurado.ValorPatrimonio
                }
              })
            }

            if (this.isCreateSegurado) {
              //tive que concatenar os obj para ter vinculo do tomador com o segurado na hora da criaçao do segurado
              //anteriormente so cadastrava quando ja existia um seguradoid
              const concatSeguradoTomador = {
                ...dadosFormSegurado,
                tomadorId: this.dados.id,
              }
              useJwt
                .post(`cadastro/tomador/`, concatSeguradoTomador)
                .then((response) => {
                  this.$message.info('Salvando...')
                })
                .finally(() => {
                  this.$message.success('Segurado cadastrado com sucesso!')
                  this.isCreateSegurado = false
                  this.eraseFormSegurado()
                })
            } else {
              this.$message.info('Salvando...')
              useJwt.put(`cadastro/tomador/updateSegurado/${dadosFormSegurado.id}`, dadosFormSegurado).then((response) => {
                this.$message.success('Segurado alterado com sucesso!')
                this.eraseFormSegurado()
              })
            }
          }
        })
      },
      eraseFormSegurado() {
        this.segurado.matricula = null
        this.segurado.orgao = null
        this.segurado.categoria = ''
        this.segurado.dataAdmissao = ''
        this.segurado.dataFimBeneficio = ''
        this.segurado.remuneracao = '0.00'
        this.segurado.margemUtilizada = '0.00'
        this.segurado.margemDisponivel = '0.00'
        this.segurado.grupoFolhaId = null
        this.segurado.dataExoneracao = ''
        this.segurado.bloqueioJudicial = false
        this.segurado.dataBloqueioJudicial = ''
        this.segurado.profissaoId = null
        this.segurado.profissaoOutros = ''
        this.segurado.CNPJInstituicao = ''
        this.segurado.ValorPatrimonio = '0.00'
        this.isCreateSegurado = true

        if (this.segurado.id) delete this.segurado.id

        this.$refs.formularioSegurado.reset()
      },
      validaDataSegurado(campo) {
        let erros = []

        const dataInicioBeneficio = formatarTipoDate(this.segurado.dataInicioBeneficio)
        const dataNascimento = formatarTipoDate(this.dados.dataNascimento)
        const dataAdmissao = formatarTipoDate(this.segurado.dataAdmissao)
        const categoria = this.segurado.categoria

        // Data de admissão
        if (campo == 'dataAdmissao' && this.segurado.dataAdmissao) {
          if (!this.validarData(this.segurado.dataAdmissao)) erros.push('A data de admissão é inválida!')

          if (
            categoria == 'Pensionista' &&
            this.segurado.dataAdmissao > this.segurado.dataFimBeneficio &&
            this.segurado.dataFimBeneficio
          ) {
            erros.push('A data de admissão não pode ser superior a data fim do benefício!')
            this.segurado.dataAdmissao = ''
          }
          if (dataAdmissao < dataNascimento) {
            erros.push('A data de admissão não pode ser inferior a data de nascimento do tomador!')
            this.segurado.dataAdmissao = ''
          }
        }
        //  Data de início do benefício
        if (campo == 'dataInicioBeneficio' && this.segurado.dataInicioBeneficio) {
          if (!this.validarData(this.segurado.dataInicioBeneficio)) erros.push('A data início do benefício é inválida!')
          if (dataInicioBeneficio < dataNascimento) {
            erros.push('A data início do benefício não pode ser inferior a data de nascimento!')
            this.segurado.dataInicioBeneficio = ''
          }
        }

        // Data de emissão do RG
        if (campo == 'rgDataEmissao' && this.dados.rgDataEmissao) {
          if (!this.validarData(this.dados.rgDataEmissao)) erros.push('A data emissão do RG  é inválida!')

          if (this.dados.rgDataEmissao < dataNascimento) {
            erros.push('A data emissão do RG não pode ser inferior a data de nascimento!')
            this.dados.rgDataEmissao = ''
          }
        }

        // Data de fim do benefício
        if (campo == 'dataFimBeneficio' && this.segurado.dataFimBeneficio) {
          if (!this.validarData(this.segurado.dataFimBeneficio)) erros.push('A data fim do benefício é inválida!')
          if (formatarDataGlobal(this.segurado.dataFimBeneficio) < formatarDataGlobal(this.segurado.dataInicioBeneficio)) {
            erros.push('A data fim do benefício não pode ser inferior a data de inicio do benefício!')
            this.segurado.dataFimBeneficio = ''
          }
          if (formatarDataGlobal(this.segurado.dataFimBeneficio) < formatarDataGlobal(dataNascimento)) {
            erros.push('A data fim do benefício não pode ser inferior a data de nascimento!')
            this.segurado.dataFimBeneficio = ''
          }
        }

        // Data de óbito
        if (campo == 'dataObito' && this.dados.dataObito) {
          if (!this.validarData(this.dados.dataObito)) erros.push('A data de óbito é inválida!')
          if (this.dados.dataNascimento < this.dados.dataObito) {
            erros.push('A data de óbito não pode ser inferior a data de nascimento!')
            this.dados.dataObito = ''
          }
          if (this.dados.dataObito < this.dados.dataInicioBeneficio) {
            erros.push('A data de óbito não pode ser inferior a data de início do benefício!')
            this.dados.dataObito = ''
          }
        }
        //Data bloqueio judicial
        if (campo == 'dataBloqueioJudicial') {
          if (!this.validarData(this.segurado.dataBloqueioJudicial)) erros.push('A data de bloqueio judicial é inválida!')
        }
        if (erros?.length > 0) {
          erros.forEach((erro) => {
            this.$message.error(erro)
          })
        }
      },
      validaCamposDocumentos(campo, id) {
        let erros = []

        switch (id) {
          case 'rgNumero':
            if (campo?.length > 0 && !validaRG(campo)) {
              erros.push('RG inválido.')
              this.dados.rgNumero = ''
            }
            break
          case 'cpf':
            if (campo?.length > 0 && !isCPFValid(campo)) {
              erros.push('CPF inválido.')
              this.dados.cpf = ''
            }
            break
          case 'chavePixCPF':
            if (campo && !isCPFValid(campo)) {
              erros.push('CPF do pix inválido.')
              this.dados.chavePix = ''
            }
            break
          case 'chavePixCNPJ':
            if (campo && !validarCnpj(campo)) {
              erros.push('CNPJ do pix inválido.')
              this.dados.chavePix = ''
            }
            break
          case 'chavePixEMAIL':
            if (campo && !validarEmail(campo)) {
              erros.push('E-mail do pix inválido.')
              this.dados.chavePix = ''
            }
            break
          case 'chavePixTELEFONE':
            if (campo && !validarTelefone(campo)) {
              erros.push('Telefone do pix inválido.')
              this.dados.chavePix = ''
            }
            break
          default:
            break
        }
        if (erros?.length > 0) {
          erros.forEach((erro) => {
            this.$message.error(erro)
          })
        }
      },
      editarSegurado(segurado) {
        this.eraseFormSegurado()

        let remuneracao = !segurado.remuneracao
          ? '0.00'
          : String(segurado.remuneracao).includes('.')
          ? Number(segurado.remuneracao)
          : Number(segurado.remuneracao) * 100
        let margemUtilizada = !segurado.margemUtilizada
          ? '0.00'
          : String(segurado.margemUtilizada).includes('.')
          ? Number(segurado.margemUtilizada)
          : Number(segurado.margemUtilizada) * 100
        let margemDisponivel = !segurado.margemDisponivel
          ? '0.00'
          : String(segurado.margemDisponivel).includes('.')
          ? Number(segurado.margemDisponivel)
          : Number(segurado.margemDisponivel) * 100

        let formSegurado = {
          matricula: segurado.matricula,
          orgao: segurado.orgao,
          categoria: segurado.situacaoPrevidenciaria,
          remuneracao: remuneracao,
          margemUtilizada: margemUtilizada,
          margemDisponivel: margemDisponivel,
          ehVitalicio: segurado.ehVitalicio ? segurado.ehVitalicio : false,
          grupoFolhaId: segurado.grupoFolhaId,
          tipoBeneficio: segurado.tipoBeneficio,
          exonerado: segurado.exonerado ? segurado.exonerado : false,
          portariaExoneracao: segurado.portariaExoneracao,
          bloqueioJudicial: segurado.bloqueioJudicial,
          dataAdmissao: segurado.dataAdmissao ? formatarData(segurado.dataAdmissao) : null,
          dataExoneracao: segurado.dataExoneracao ? formatarData(segurado.dataExoneracao) : null,
          dataInicioBeneficio: segurado.dataInicioBeneficio ? formatarData(segurado.dataInicioBeneficio) : null,
          dataFimBeneficio: segurado.dataFimBeneficio ? formatarData(segurado.dataFimBeneficio) : null,
          dataBloqueioJudicial: segurado.dataBloqueioJudicial ? formatarData(segurado.dataBloqueioJudicial) : null,
          profissaoId: segurado.profissaoId ? segurado.profissaoId : null,
          profissaoOutros: segurado.profissaoOutros ? segurado.profissaoOutros : null,
          CNPJInstituicao: segurado.CNPJInstituicao ? segurado.CNPJInstituicao : null,
          ValorPatrimonio: segurado.ValorPatrimonio ? segurado.ValorPatrimonio : null,
        }

        // Buscar dados da portaria para preencher a variável para download
        if (segurado.exonerado && segurado.id) {
          useJwt
            .get(`cadastro/tomador/GetPortariaExoneracaoSegurado/${segurado.id}`)
            .then((response) => {
              this.portariaExoneracaoAnexada = response.data
            })
            .catch((error) => {
              console.error(error)
            })
        }

        if (segurado.id) formSegurado['id'] = segurado.id

        this.segurado = formSegurado
        this.isCreateSegurado = false

        this.carregarGrupoFolha()
      },
      excluirSegurado(segurado) {
        const parametros = {
          seguradoId: segurado,
          institutoId: this.dados.institutoId,
        }

        useJwt
          .post('cadastro/tomador/GetPodeExcluirSegurado', parametros)
          .then((response) => {
            const { propostaQuantidade } = response.data
            const { simulacaoQuantidade } = response.data
            if (propostaQuantidade > 0 || simulacaoQuantidade > 0) {
              const simulacoes = `${simulacaoQuantidade} simulação(ões)`
              const propostas = `${propostaQuantidade} proposta(s)`
              const ligacao = propostaQuantidade > 0 && simulacaoQuantidade > 0 ? 'e' : ''
              const messagem = `Esse segurado já está associado à ${simulacaoQuantidade > 0 ? simulacoes : ''} ${ligacao} ${
                propostaQuantidade > 0 ? propostas : ''
              }`
              this.$message.error(messagem)
              return
            }

            if (segurado) {
              this.excluirSegurados.push(segurado)
              this.dados.excluirSegurados = this.excluirSegurados
            }

            this.tomadorSegurados = this.tomadorSegurados.filter((rowSegurado) => rowSegurado.id != segurado)
            this.dados.segurados = this.tomadorSegurados
          })
          .catch((error) => {
            console.error(error)
            this.$message.error('Não foi possível excluir segurado!')
          })
      },
      preencheMargemDisponivel() {
        const remuneracao = formatarParaNumber(this.segurado.remuneracao)
        if (isNumber(remuneracao)) {
          const valorRemuneracao = remuneracao
          const porcentagemMargemParametrizada = Number(Number(this.userData.Instituto.margemConsignavel) / 100).toFixed(2)
          this.segurado.margemDisponivel = Number(valorRemuneracao * porcentagemMargemParametrizada).toFixed(2)
        }
      },
      limpaGrupoFolha() {
        this.segurado.grupoFolhaId = null
      },
      insereCertidaoObito() {
        const formData = new FormData()
        const nomeTomador = String(this.dados.nomeCompleto).split(' ')[0]

        formData.append('nome', 'CertidaoObito - ' + nomeTomador)
        formData.append('fileName', 'CertidaoObito - ' + nomeTomador)
        formData.append('institutoId', this.dados.institutoId)
        if (this.dados.id) formData.append('tomadorId', this.dados.id)
        let file = this.$refs.certidaoObitoFile.files[0]
        formData.append('file', file)

        useJwt
          .postDocumento(`cadastro/tomador/uploadCertidaoObito`, (event) => {}, formData)
          .then((response) => {})
          .catch((error) => {
            console.error(error)
            this.$message.error(String(error))
          })
      },
      inserePortariaExoneracao() {
        const formData = new FormData()
        const nomeTomador = String(this.dados.nomeCompleto).split(' ')[0]

        formData.append('nome', 'Portaria de Exoneração - ' + nomeTomador)
        formData.append('fileName', 'Portaria de Exoneração - ' + nomeTomador)
        formData.append('institutoId', this.dados.institutoId)
        if (this.dados.id) formData.append('tomadorId', this.dados.id)
        let file = this.$refs.certidaoObitoFile.files[0]
        formData.append('file', file)

        useJwt
          .postDocumento(`cadastro/tomador/uploadCertidaoObito`, (event) => {}, formData)
          .then((response) => {})
          .catch((error) => {
            console.error(error)
            this.$message.error(String(error))
          })
      },
      downloadPortariaExoneracaoAnexada() {
        window.open(this.portariaExoneracaoAnexada.s3url)
      },
      excluirPortariaExoneracaoAnexada() {
        if (this.portariaExoneracaoAnexada && this.portariaExoneracaoAnexada.id) {
          this.portariaExoneracaoAnexada.id = null
        }
      },
      carregarClientes() {
        useJwt
          .get('cadastro/instituto')
          .then((response) => {
            this.clientes = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },

      formatarDataISO(dataISO) {
        if (!dataISO) return ''
        const [ano, mes, dia] = dataISO.split('-')
        return `${dia}/${mes}/${ano}`
      },
    },
  }
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .camera-canvas {
    text-align: center;
  }

  #modal-foto___BV_modal_footer_ {
    margin-left: auto;
    left: 0px;
    right: 0px;
    margin-right: auto;
  }

  label[for='btnCreateEditSegurado'],
  label[for='btnEraseFormSegurado'] {
    height: 17.39px;
  }

  [dir] body.dark-layout #portadorDoencaIncapacitante > label.btn.btn-outline-primary.active > span,
  [dir] body.dark-layout #portadorMolestiaGrave > label.btn.btn-outline-primary.active > span,
  [dir] body.dark-layout #falecido > label.btn.btn-outline-primary.active > span {
    [dir] body.dark-layout #exonerado > label.btn.btn-outline-primary.active > span {
      color: #ecf0f1;
    }
  }

  .breakWord {
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
  }

  .flexRowReverse {
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
  }
  .custom-select {
    color: #6e6b7b !important;
    opacity: 1 !important;
    cursor: pointer !important;
  }
</style>
